import { AttachInfo } from "../../../../../../Common/CandyApiClient/Types/Attachments/Attacments";

import { AttachmentState } from "./AttachmentsReducer";

export enum AttachmentsActionType {
    LoadInitialAttachments = "LoadInitialAttachments",
    AddAttachments = "ADD_ATTACHMENTS",
    RemoveAttachment = "REMOVE_ATTACHMENT",
    UpdateAttachment = "UPDATE_ATTACHMENT",
    SetAttachmentProgress = "SET_ATTACHMENT_PROGRESS",
}

export type AttachmentAction =
    | { type: AttachmentsActionType.LoadInitialAttachments; payload: AttachmentState }
    | { type: AttachmentsActionType.AddAttachments; payload: AttachInfo[] }
    | { type: AttachmentsActionType.RemoveAttachment; payload: { id: string } }
    | { type: AttachmentsActionType.UpdateAttachment; payload: { id: string; attachment: AttachInfo } }
    | { type: AttachmentsActionType.SetAttachmentProgress; payload: { id: string; progress: number } };

export function loadInitialAttachments(attachmentState: AttachmentState): AttachmentAction {
    return { type: AttachmentsActionType.LoadInitialAttachments, payload: attachmentState };
}

export function addAttachments(attachments: AttachInfo[]): AttachmentAction {
    return {
        type: AttachmentsActionType.AddAttachments,
        payload: attachments,
    };
}

export function removeAttachment(id: string): AttachmentAction {
    return {
        type: AttachmentsActionType.RemoveAttachment,
        payload: {
            id: id,
        },
    };
}

export function updateAttachment(id: string, attachment: AttachInfo): AttachmentAction {
    return {
        type: AttachmentsActionType.UpdateAttachment,
        payload: {
            id: id,
            attachment: attachment,
        },
    };
}

export function setAttachmentProgress(id: string, progress: number): AttachmentAction {
    return {
        type: AttachmentsActionType.SetAttachmentProgress,
        payload: { id: id, progress: progress },
    };
}
